import {Badge, Icon, InfoTooltip} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {getInstructionStatusDisplay} from '../config/buyers.config';

import type {PaymentInstructionDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface PaymentInstructionStatusBadgeProps {
  instruction: PaymentInstructionDTO;
}

export const PaymentInstructionStatusBadge: FC<PaymentInstructionStatusBadgeProps> = ({
  instruction
}) => {
  const {t} = useTranslation('trustAccounts');
  const {variant, icon, statusKey, tooltipKey} = getInstructionStatusDisplay(instruction);

  return (
    <div className="flex items-center gap-1">
      <Badge variant={variant} size="sm">
        <Icon name={icon} className="size-3" />
        {t(`view.buyers.detail.instructionStatus.${statusKey}`)}
      </Badge>
      {tooltipKey && (
        <InfoTooltip content={t(`view.buyers.detail.instructionStatusTooltip.${tooltipKey}`)} />
      )}
    </div>
  );
};
